"use client"

import { Button } from "../components/ui/button"
import { Card, CardContent } from "../components/ui/card"
import { motion, Variants } from "framer-motion"

import planDietaImage from "../../../../assets/img/plandieta.jpg"
import planPsicologiaImage from "../../../../assets/img/planpsicologia.jpg"

const products = [
  {
    id: 1,
    title: "Plan de dieta",
    description:
      "Programa nutricional personalizado para alcanzar tus objetivos de salud y bienestar.",
    image: planDietaImage,
    link: "https://vikika.es/productos/dieta"
  },
  {
    id: 2,
    title: "Plan de psicología",
    description: "Acompañamiento psicológico profesional para tu crecimiento personal y emocional.",
    image: planPsicologiaImage,
    link: "https://vikika.es/productos/psicologia"
  }
]

// Variantes de animación para el carrusel
const cardVariants: Variants = {
  hidden: { opacity: 0, scale: 0.8, y: 50 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  },
  hover: {
    scale: 1.05,
    y: -10,
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
}

const buttonVariants: Variants = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: "easeOut"
    }
  },
  hover: {
    scale: 1.1,
    transition: {
      duration: 0.2
    }
  },
  tap: {
    scale: 0.9
  }
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
}

export default function ProductCarousel() {
  return (
    <motion.div
      className="relative"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      <div className="overflow-hidden">
        <motion.div className="flex flex-col md:flex-row gap-6 items-center md:justify-center">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              className="w-80"
              variants={cardVariants}
              whileHover="hover"
              initial="hidden"
              animate="visible"
              transition={{ delay: index * 0.1 }}
            >
              <Card
                className="overflow-hidden shadow-lg border-0 h-full"
                style={{ backgroundColor: "#f2f2f2" }}
              >
                <motion.div
                  className="relative h-48"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <img
                    src={product.image || "/placeholder.svg"}
                    alt={product.title}
                    className="w-full h-full object-cover"
                  />
                </motion.div>
                <CardContent className="p-4">
                  <motion.h3
                    className="text-lg font-semibold mb-2"
                    style={{ color: "#314037" }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                  >
                    {product.title}
                  </motion.h3>
                  <motion.p
                    className="text-sm mb-3"
                    style={{ color: "#68736e" }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                  >
                    {product.description}
                  </motion.p>
                  <motion.div
                    className="flex justify-center"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                  >
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button
                        size="sm"
                        className="text-white border-0"
                        style={{ backgroundColor: "#314037" }}
                        onClick={() => window.open(product.link, "_blank")}
                      >
                        Ver más
                      </Button>
                    </motion.div>
                  </motion.div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  )
}
